<div class="organization-info">
	<div class="company-main-info">
		<app-favorite-heart
			[isFavorite]="isFavorite"
			size="medium"
			(favoriteToggle)="onToggleFavoriteWrapper()"
		></app-favorite-heart>
		<div class="company-details">
			<div class="company-name-section">
				<h4 class="company-name to-ellipsis">
					{{ name }}
					<span
						class="badge"
						[class]="isMatriz ? 'matriz' : 'filial'"
						tabindex="0"
					>
						{{ isMatriz ? 'Matriz' : 'Filial' }}
					</span>
				</h4>
				<span class="company-cnpj">{{ cnpj }}</span>
			</div>
		</div>
	</div>

	<div class="company-metrics">
		<div class="metric-item hide-on-mobile">
			<span class="metric-label">Usuários</span>
			<span class="metric-value">{{ totalUsers || 0 }}</span>
		</div>
		<div class="metric-item">
			<span class="metric-label">Beneficiários</span>
			<span class="metric-value">{{ totalBeneficiaries || 0 }}</span>
		</div>
	</div>

	<div class="company-tags">
		<div class="tag-group">
			<span class="tag-label">Corretora</span>
			<div class="tag-container">
				<span
					class="badge"
					[class]="getBrokerStatusClass()"
					[matTooltip]="getBrokerStatusText()"
					tabindex="0"
				>
					{{ getBrokerStatusText() }}
				</span>
			</div>
		</div>
		<div class="tag-group">
			<span class="tag-label">Produtos</span>
			<div class="tag-container">
				<ng-container *ngIf="products && products.length > 0; else noProducts">
					<span
						*ngFor="let product of products"
						class="badge"
						[ngClass]="getProductTagClass(product.products.name)"
						[matTooltip]="product.products.name"
						tabindex="0"
					>
						{{ product.products.name }}
					</span>
				</ng-container>
				<ng-template #noProducts>
					<span
						class="badge without-products"
						matTooltip="Nenhum produto vinculado"
						tabindex="0"
					>
						Sem Produtos
					</span>
				</ng-template>
			</div>
		</div>
	</div>

	<div class="company-actions">
		<button
			mat-flat-button
			color="primary"
			(click)="onEditGroup(name)"
			class="manage-button"
		>
			<mat-icon>settings</mat-icon>
			<span class="hide-on-mobile">Gerenciar</span>
		</button>
	</div>
</div>
